import { Link } from "react-router-dom";
import { HelpCircle, ArrowLeft, Package, HardDrive, Video, CreditCard, BarChart3, Shield, Sparkles, ChevronDown } from "lucide-react";
import { useState, useEffect } from "react";

export default function FAQ() {
  const [openQuestion, setOpenQuestion] = useState<string | null>(null);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const toggleQuestion = (id: string) => {
    setOpenQuestion(openQuestion === id ? null : id);
  };

  const faqSections = [
    {
      icon: Package,
      title: "การใช้งานทั่วไป",
      color: "purple",
      questions: [
        {
          id: "general-1",
          q: "EduMi คืออะไร?",
          a: "EduMi คือแพลตฟอร์มสำหรับผู้สอนและเจ้าของความรู้ ใช้สร้างคอร์สเรียน ขายความรู้ และจัดการนักเรียนได้อย่างเป็นระบบ โดยไม่ต้องสร้างเว็บเอง และไม่โดนหักส่วนแบ่งจากยอดขาย"
        },
        {
          id: "general-2",
          q: "EduMi เหมาะกับใคร?",
          a: "เหมาะกับครู โค้ช วิทยากร เจ้าของสูตร หรือคนที่อยากขายความรู้ของตัวเองแบบจริงจัง และไม่อยากดูแลระบบเทคนิคเอง\n\nไม่เหมาะกับผู้ที่ต้องการทำ Marketplace รวมหลายครูในเว็บเดียว หรือระบบ Live streaming หนัก ๆ"
        }
      ]
    },
    {
      icon: HardDrive,
      title: "ห้องเรียนและความจุ",
      color: "green",
      questions: [
        {
          id: "storage-1",
          q: "EduMi คิดค่าบริการจากอะไร?",
          a: "Pro และ Pro+ รองรับนักเรียนไม่จำกัด\n\n• Pro: ฿690/เดือน (20GB)\n• Pro+: ฿1,590/เดือน (30GB + SEO)\n\nหากต้องการพื้นที่เพิ่ม สามารถซื้อ Add-on เพิ่มพื้นที่ได้ (+10GB ถึง +200GB)"
        },
        {
          id: "storage-2",
          q: "ถ้ามีนักเรียน 3,000 คน ต้องทำยังไง?",
          a: "Pro และ Pro+ รองรับนักเรียนไม่จำกัด\n\nไม่ต้องกังวลเรื่องจำนวนนักเรียน ไม่ว่าจะ 3,000 หรือ 30,000 คน\n\nคุณจ่ายเพียงค่าพื้นที่จัดเก็บ:\n• Pro: ฿690/เดือน (20GB)\n• Pro+: ฿1,590/เดือน (30GB)"
        },
        {
          id: "storage-3",
          q: "ลบวิดีโอหรือไฟล์แล้ว พื้นที่จะได้คืนไหม?",
          a: "ได้คืนทันที เมื่อคุณลบวิดีโอ รูป หรือไฟล์เอกสารออก พื้นที่จะกลับมาใช้งานได้ทันที"
        },
        {
          id: "storage-4",
          q: "ถ้าพื้นที่คอร์สเต็ม จะเกิดอะไรขึ้น?",
          a: "นักเรียนยังเรียนได้ตามปกติ วิดีโอเดิมยังดูได้\n\nแต่จะไม่สามารถอัปโหลดวิดีโอใหม่ได้ จนกว่าจะลบไฟล์หรือเพิ่มพื้นที่ด้วย Add-on\n\nระบบจะแจ้งเตือนเมื่อใกล้เต็ม"
        }
      ]
    },
    {
      icon: Video,
      title: "วิดีโอการสอน",
      color: "orange",
      questions: [
        {
          id: "video-1",
          q: "รองรับวิดีโอแบบไหน?",
          a: "รองรับไฟล์วิดีโอ MP4 เป็นหลัก ระบบถูกออกแบบให้เล่นได้ทั้งมือถือและคอมพิวเตอร์อย่างเสถียร"
        },
        {
          id: "video-2",
          q: "ความละเอียดวิดีโอมีผลกับค่าใช้จ่ายไหม?",
          a: "ไม่มีผลต่อค่าบริการแพ็กเกจ แต่ไฟล์ที่ความละเอียดสูงจะใช้พื้นที่มากกว่า\n\nแนะนำให้ใช้ 480p หรือ 720p คุณภาพดีพอสำหรับการเรียน และประหยัดพื้นที่"
        },
        {
          id: "video-3",
          q: "ระบบมีโฆษณาคั่นวิดีโอไหม?",
          a: "ไม่มี วิดีโอของคุณไม่มีโฆษณา ไม่มีโลโก้แทรก นักเรียนโฟกัสกับการเรียนได้เต็มที่"
        }
      ]
    },
    {
      icon: CreditCard,
      title: "ราคา & แพ็กเกจ",
      color: "blue",
      questions: [
        {
          id: "pricing-1",
          q: "มีแพ็กเกจอะไรบ้าง?",
          a: "ปัจจุบันมี 3 ตัวเลือก:\n\n• Free Trial (14 วัน) - ทดสอบระบบ รองรับ 20 คน\n• Pro (฿690/เดือน หรือ ฿6,900/ปี) - ไม่จำกัดนักเรียน 20GB\n• Pro+ (฿1,590/เดือน หรือ ฿15,900/ปี) - ไม่จำกัดนักเรียน 30GB + SEO\n\nทั้ง Pro และ Pro+ สามารถเพิ่มพื้นที่ได้ด้วย Add-on:\n• +10GB = 149฿/เดือน\n• +25GB = 299฿/เดือน\n• +50GB = 549฿/เดือน\n• +100GB = 899฿/เดือน\n• +200GB = 1,499฿/เดือน\n\nรายละเอียดแสดงชัดเจนในหน้า Pricing"
        },
        {
          id: "pricing-2",
          q: "Add-on คืออะไร?",
          a: "Add-on คือการเพิ่มพื้นที่จัดเก็บ (นักเรียนไม่จำกัดอยู่แล้ว)\n\nราคา Add-on:\n• +10GB = 149฿/เดือน (1,490฿/ปี)\n• +25GB = 299฿/เดือน (2,990฿/ปี)\n• +50GB = 549฿/เดือน (5,490฿/ปี)\n• +100GB = 899฿/เดือน (8,990฿/ปี)\n• +200GB = 1,499฿/เดือน (14,990฿/ปี)\n\nไม่บังคับซื้อ ซื้อเมื่อต้องการเพิ่มพื้นที่เท่านั้น"
        },
        {
          id: "pricing-3",
          q: "Free Trial 30 วัน หมดแล้วจะเกิดอะไร?",
          a: "หลังจาก 30 วัน คุณสามารถเลือก:\n\n1. อัปเกรดเป็น Pro+ - ใช้งานต่อได้ทันที\n2. ไม่อัปเกรด - ระบบจะหยุดใช้งาน แต่ข้อมูลยังอยู่\n\nไม่มีการเรียกเก็บเงินอัตโนมัติ คุณควบคุมค่าใช้จ่ายได้ทั้งหมด"
        }
      ]
    },
    {
      icon: BarChart3,
      title: "Dashboard & รายงาน",
      color: "pink",
      questions: [
        {
          id: "dashboard-1",
          q: "Dashboard เป็น Real-time ไหม?",
          a: "Dashboard เป็นข้อมูลสรุปแบบอัปเดตเป็นรอบ เพื่อให้ระบบเสถียร และค่าบริการไม่แพงเกินจำเป็น\n\nแสดงภาพรวม แนวโน้ม และสรุปรายช่วงเวลา"
        },
        {
          id: "dashboard-2",
          q: "นักเรียนเห็นข้อมูลอะไรบ้าง?",
          a: "นักเรียนจะเห็นเฉพาะคอร์สที่สมัคร และความคืบหน้าการเรียนของตัวเอง ไม่เห็นข้อมูลของผู้อื่น"
        }
      ]
    },
    {
      icon: Shield,
      title: "ความปลอดภัย",
      color: "red",
      questions: [
        {
          id: "security-1",
          q: "วิดีโอถูกนำไปแชร์ต่อได้ไหม?",
          a: "วิดีโอถูกออกแบบให้ดูผ่านระบบ EduMi เท่านั้น ไม่มีโฆษณา และไม่ใช่ลิงก์ YouTube\n\nระบบช่วยลดความเสี่ยง แต่ไม่สามารถป้องกันการอัดหน้าจอได้ 100% ซึ่งเป็นข้อจำกัดของทุกแพลตฟอร์ม"
        }
      ]
    },
    {
      icon: Sparkles,
      title: "คำถามสุดท้าย",
      color: "violet",
      questions: [
        {
          id: "final-1",
          q: "ถ้าไม่แน่ใจ ควรเริ่มจากอะไร?",
          a: "แนะนำให้เริ่มจาก Free Trial 30 วัน\n\nลองสร้างคอร์ส อัปโหลดวิดีโอ เชิญนักเรียนทดสอบ\nดูว่าระบบเหมาะกับคุณหรือไม่\n\nไม่ต้องใช้บัตรเครดิต ไม่มีค่าใช้จ่าย"
        }
      ]
    }
  ];

  const colorClasses: Record<string, { bg: string; border: string; icon: string; text: string }> = {
    purple: { bg: "from-purple-50 to-pink-50", border: "border-blue-200", icon: "text-blue-600", text: "text-blue-700" },
    green: { bg: "from-green-50 to-emerald-50", border: "border-green-200", icon: "text-green-600", text: "text-green-700" },
    orange: { bg: "from-orange-50 to-amber-50", border: "border-blue-200", icon: "text-blue-600", text: "text-blue-700" },
    blue: { bg: "from-blue-50 to-cyan-50", border: "border-blue-200", icon: "text-blue-600", text: "text-blue-700" },
    pink: { bg: "from-pink-50 to-rose-50", border: "border-pink-200", icon: "text-pink-600", text: "text-pink-700" },
    red: { bg: "from-red-50 to-pink-50", border: "border-red-200", icon: "text-red-600", text: "text-red-700" },
    violet: { bg: "from-violet-50 to-purple-50", border: "border-cyan-200", icon: "text-cyan-600", text: "text-cyan-700" }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-purple-50/20 to-pink-50/20 py-8 sm:py-12">
      <div className="max-w-4xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12">
          <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm mb-4">
            <HelpCircle className="w-5 h-5 text-blue-600" />
            <span className="text-sm font-medium text-gray-700">คำถามที่พบบ่อย</span>
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            มีคำถามเกี่ยวกับ EduMi?
          </h1>
          <p className="text-base sm:text-lg text-gray-600">
            คำตอบสำหรับคำถามที่ผู้ใช้งานถามบ่อยที่สุด
          </p>
        </div>

        {/* FAQ Content */}
        <div className="space-y-10">
          {faqSections.map((section, sectionIndex) => {
            const colors = colorClasses[section.color];
            const SectionIcon = section.icon;
            
            return (
              <div key={sectionIndex}>
                <div className="flex items-center gap-3 mb-5">
                  <div className={`p-2.5 rounded-xl bg-gradient-to-br ${colors.bg}`}>
                    <SectionIcon className={`w-5 h-5 md:w-6 md:h-6 ${colors.icon}`} />
                  </div>
                  <h2 className="text-xl md:text-2xl font-bold text-textDark">
                    {section.title}
                  </h2>
                </div>

                <div className="space-y-3">
                  {section.questions.map((item) => {
                    const isOpen = openQuestion === item.id;
                    
                    return (
                      <div
                        key={item.id}
                        className="bg-white rounded-xl border border-gray-200 overflow-hidden transition-all duration-300 hover:shadow-md"
                      >
                        <button
                          onClick={() => toggleQuestion(item.id)}
                          className="w-full px-5 md:px-6 py-4 text-left flex items-start justify-between gap-4 hover:bg-gray-50 transition-colors"
                        >
                          <h3 className="text-base md:text-lg font-semibold text-textDark flex-1">
                            {item.q}
                          </h3>
                          <ChevronDown className={`w-5 h-5 text-gray-400 flex-shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
                        </button>
                        
                        {isOpen && (
                          <div className="px-5 md:px-6 pb-4 animate-fadeIn">
                            <div className="text-sm md:text-base text-gray-600 leading-relaxed whitespace-pre-line">
                              {item.a}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>

        {/* Footer Message */}
        <div className="mt-12 md:mt-16 bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-6 md:p-10 text-center border border-blue-200">
          <Sparkles className="w-10 h-10 md:w-12 md:h-12 text-blue-600 mx-auto mb-3 md:mb-4" />
          <h3 className="text-xl md:text-2xl font-bold text-textDark mb-2 md:mb-3">
            EduMi ไม่ใช่แพลตฟอร์มที่ขายฝัน
          </h3>
          <p className="text-sm md:text-base text-gray-600 max-w-2xl mx-auto">
            แต่เป็นเครื่องมือที่ช่วยให้คนที่มีของจริง เอาความรู้ไปสร้างรายได้อย่างยั่งยืน
          </p>
        </div>

        {/* CTA Section */}
        <div className="mt-8 md:mt-10 text-center">
          <Link to="/register">
            <button className="bg-gradient-to-r from-blue-600 to-pink-600 hover:shadow-xl text-white px-10 md:px-12 py-3.5 md:py-4 rounded-xl text-base md:text-lg font-bold transition-all duration-300 transform hover:scale-105">
              เริ่มใช้งานฟรี
            </button>
          </Link>
          <p className="mt-3 md:mt-4 text-gray-500 text-xs md:text-sm">
            ไม่ต้องใช้บัตรเครดิต • Free Trial 30 วัน
          </p>
        </div>
      </div>
    </div>
  );
}
